module.exports = function() {
  return new Worker(__webpack_public_path__ + "2e2d15c250a18fb8d4b7.worker.js");
};